import { useLocation } from 'react-router-dom';
import { ProductCategoryConstant } from '../../../../constants/product/product.constant';
import { useCheckUserLoggedIn } from '../../../../hooks/user/useCheckUserLoggedIn';
import { IProduct } from '../../../../interfaces/Product.interfaces';
import { ProductImageSection } from '../components/ProductImageSection';
import { ProductCarouselSection } from './components/ProductCarouselSection';
import { ProductCategoryAndSpecSection } from './components/ProductCategoryAndSpecSection';
import { ProductContentImageSection } from './components/ProductContentImageSection';
import { ProductInfoAndPriceSection } from './components/ProductInfoAndPriceSection';
import { ProductMarketPriceSection } from './components/ProductMarketPriceSection';
import { ProductMorePartnerProductSection } from './components/ProductMorePartnerProductSection';
import { ProductMorePluvaProductSection } from './components/ProductMorePluvaProductSection';
import { ProductOptionAndMachineTableSection } from './components/ProductOptionAndMachineTableSection';
import { ProductPluvaWaySection } from './components/ProductPluvaWaySection';
import { ProductRecommendReasonSection } from './components/ProductRecommendReasonSection';
import { ProductYoutubeSection } from './components/ProductYoutubeSection';
import { SecitionDivideLine } from './components/SecitionDivideLine';

interface ProductDetailViewProps {
  product: IProduct | undefined;
  category: 'PLUVA' | 'PARTNER';
}

export const ProductDetailView = ({ product, category }: ProductDetailViewProps) => {
  const location = useLocation();
  const { isUserLoggedIn } = useCheckUserLoggedIn();

  if (product) {
    return (
      <>
        <ProductImageSection
          images={product.images}
          status={product.status}
          pageType={'pdp'}
          productTitle={product.title}
          productCode={product.code}
        />

        <ProductInfoAndPriceSection product={product} category={category} />

        <ProductCategoryAndSpecSection product={product} category={category} />

        <ProductMarketPriceSection product={product} category={category} />

        <SecitionDivideLine />

        {(category === ProductCategoryConstant.PLUVA || category === ProductCategoryConstant.PARTNER) &&
          product.youtubeUrl && <ProductYoutubeSection product={product} />}

        <SecitionDivideLine />

        <ProductOptionAndMachineTableSection product={product} />

        {product.content && <ProductRecommendReasonSection product={product} />}

        {category === ProductCategoryConstant.PLUVA && <ProductPluvaWaySection product={product} />}

        <SecitionDivideLine />

        <ProductMorePluvaProductSection product={product} />

        {product.contentImageUrl && <ProductContentImageSection product={product} />}

        <ProductCarouselSection />

        <ProductMorePartnerProductSection product={product} />
      </>
    );
  }

  return null;
};
